export default {
  services: '/services',
  servicesQuotes: '/services/quotes',
  servicesInquiries: '/services/inquiries',
  servicesQuotesGroupDetails: '/services/quotes/group/:groupId',
  servicesCategoryPartner: '/services/category/:categoryId/partner/:partnerId',
  servicesCategoryPartnerRequestQuote:
    '/services/category/:categoryId/partner/:partnerId/request-quote',
};
